import { useEffect } from 'react'
import { Errcode } from 'src/constants/errcode'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { setErrText } from 'src/store/Reducer/common/commonSlice'
import { AppThunk } from 'src/store/store'
import { commonUtils } from 'src/utils/common.utils'
import { CryptoUtils } from 'src/utils/Crypto.utils'
import { ResetConfirmPin, ResetCreatePin } from 'src/store/Reducer/page/resetPageSlice'
import { setModalItems } from 'src/store/Reducer/common/modalSlice'

import { ResponseDataBody, ResponseDataType } from 'src/types/websocket'
import { eventBus } from 'src/api/eventBus'
import { useLocation } from 'react-router-dom'

const useResetEventBus = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const dispatch = useAppDispatch()
  const { fcmPushHandler } = commonUtils

  useEffect(() => {
    const PinResetResponseListener = eventBus.subscribe<ResponseDataBody.PinReset>(
      Cmdtypes.PIN_RESET,
      (message: ResponseDataType<ResponseDataBody.PinReset>) =>
        dispatch(handlePinResetResponse(message)),
    )
    return () => {
      PinResetResponseListener.unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  const handlePinResetResponse = (
    message: ResponseDataType<ResponseDataBody.PinReset>,
  ): AppThunk => {
    return async (dispatch, getState) => {
      const { Header, Body } = message.responseData
      const { ConfirmPin } = getState().ResetPage
      const { Email } = getState().LoginPage
      switch (Header.ErrCode) {
        case Errcode.SUCCESS:
          await fcmPushHandler(Body.PushToken, CryptoUtils.ResetVerifyPin(ConfirmPin, Email)).then(
            (r: any) => {
              //success
              if (r?.data?.success === 1) {
                dispatch(
                  setModalItems({
                    type: 'alert',
                    text: `${t('MODAL.RESET_PIN.SUCCESS', {
                      defaultValue: 'A new PIN has been set. Please sign in again.',
                    })}`,
                    confirmFunc: () => window.location.reload(),
                  }),
                )
              } else {
                //fail
                dispatch(
                  setModalItems({
                    type: 'alert',
                    text: `${t('LOGIN.ERRTXT.IS_NOT_DOWNLOAD_OR_NOT_LOGIN', {
                      defaultValue:
                        'MFINDER not found on your device. Download MFINDER from Google Play or sign in to the app.',
                    })}`,
                    confirmFunc: () => window.location.reload(),
                  }),
                )
              }
            },
          )
          break
        default:
          dispatch(setErrText(Header.ErrMsg))
          break
      }
      dispatch(ResetCreatePin())
      dispatch(ResetConfirmPin())
    }
  }
}
export default useResetEventBus
